//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'vue-step',
  props: {
    nowStep: {
      type: Number,
      required: true
    },
    stepList: {
      type: Array,
      required: true
    },
    activeColor: {
      type: String,
      default: '#1fb11d'
    },
    styleType: {
      type: String,
      default: 'style1',
      validator: (value) => {
        return ['style1', 'style2'].indexOf(value) !== -1
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    }
  },
  computed: {
    stepItemWidth () {
      return 100 / this.stepList.length
    },
    horizontalItemWidth () {
      return this.direction === 'vertical'
        ? ''
        : { width: this.stepItemWidth + '%' }
    },
    progressStyle () {
      let oStyle = {
        'background-color': this.activeColor
      }
      if (this.direction === 'vertical') {
        oStyle.height = this.stepItemWidth * this.nowStep + '%'
      } else {
        oStyle.width = this.stepItemWidth * this.nowStep + '%'
      }
      return oStyle
    }
  },
  methods: {
    itemNumberStyle (index) {
      let style = ''
      if (index < this.nowStep) {
        style = {
          'background-color': this.activeColor,
          'color': '#fff'
        }
      }
      return style
    },
    showItemNumber (index) {
      return this.styleType !== 'style2' ? index + 1 : ''
    },
    selectItem (itemIndex) {
      this.$emit('selected', this.showItemNumber(itemIndex))
    }
  }
}
